export default __webpack_public_path__ + "stuffedCrustPep.faf51843.png";